import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {opacityChanged} from '@shared/ainmations';

export interface FormFieldError {
    errorChartIndex: number;
    errorString: string;
    valid: boolean;
}


@Component({
    selector: 'app-form-control-errors',
    templateUrl: './form-control-errors.component.html',
    styleUrls: ['./form-control-errors.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    animations: [opacityChanged]

})

export class FormControlErrorsComponent implements OnInit {

    options;
    name: string;
    errors: FormFieldError;


    textError: string;

    constructor() {
    }

    ngOnInit() {
        const errorKey = Object.keys(this.errors)[0];
        this.textError = typeof this.errors[errorKey] === 'string' ? this.errors[errorKey] : '';
    }

    initErr(field: string, params?) {
        switch (field) {
            case 'patternemail': {
                return 'Неверный формат почты';
            }
            case 'requiredemail': {
                return 'Почта обязательна';
            }
            case 'required': {
                return 'Поле обязательно для заполнения';
            }
            case 'minlength': {
                return `Минимальное количество символов - ${params.requiredLength}`;
            }
            default: {
                return 'Поле заполнено не верно';
            }
        }
        // emailpattern: 'Неверный формат почты',
        // emailrequired: 'Почта обязательна',
        // required: 'Поле обязательно для заполнения',
        // minlength: `Минимальное количество символов - 8`,
        // passEqual: 'Пароли не совпадают',
        // passNotEqual: 'Старый и новый пароли не должны совпадать',
        // wrongMail: 'Неверный логин!',
        // mailErr: 'Пользователь с таким адресом уже зарегистрирован.',
        // wrongLogin: 'Неверный логин или пароль!',
        // noSelections: 'Не удалось определить координаты по адресу.'
    };
}
